import { Navigation as NavigationModule, Scrollbar } from 'swiper';
import { SwiperSlide } from 'swiper/react';

import type { MediaWrapperTypeEnum } from '@/utils/aspectRatioUtils';

import { Card, type CardProps } from '@/components/Cms/Card';
import type { ContentfulContentGroupFragment } from '@/graphql/contentful/api';
import { useIsMdDown } from '@/hooks/useMedia';
import type { CmsExtraDataRecord } from '@/integrations/contentful';
import type { WithHTMLProp } from '@/lib/types';
import { getBreakpointSize } from '@/theme/utils';

import { S } from './SliderFullwidthGallery';
export * as SB from '@/components/BoutiqueSlider/BoutiqueSlider.styles';
export * as S from '@/cms/SliderMaxFourCards/SliderMaxFourCards.styles';
type SliderFullwidthGalleryProps = ContentfulContentGroupFragment & {
  extraDataRecord?: CmsExtraDataRecord;
} & WithHTMLProp<'className'>;
export const SliderFullwidthGallery = ({
  extraDataRecord,
  itemsCollection,
  type,
}: SliderFullwidthGalleryProps) => {
  const isMobileView = useIsMdDown();
  const slidesPerView = 4;
  const itemsCount = itemsCollection?.items.length ?? 0;
  if (itemsCollection?.items?.length === 0) return <></>;

  const breakpoints = {
    [getBreakpointSize('xs')]: {
      slidesPerView: 1.45,
      spaceBetween: 12,
    },
    [getBreakpointSize('sm')]: {
      slidesPerView: 3.5,
      spaceBetween: 12,
    },
    [getBreakpointSize('md')]: {
      slidesPerView: 3.5,
      spaceBetween: 16,
    },
    [getBreakpointSize('lg')]: {
      slidesPerView: 3.5,
      spaceBetween: 16,
    },
  };

  return (
    <S.FullWidthWrapper>
      <S.SliderSwiper
        $hideNavigation={isMobileView || slidesPerView < itemsCount}
        $separator={false}
        breakpoints={breakpoints}
        modules={[NavigationModule, Scrollbar]}
        navigation
        scrollbar={!isMobileView}
        spaceBetween={16}
      >
        {itemsCollection?.items?.map((item) => {
          const cardData = item as CardProps;
          const sysId = cardData.sys.id;
          const extraData = extraDataRecord
            ? extraDataRecord[sysId as string]
            : undefined;
          return (
            <SwiperSlide
              key={sysId}
              data-test-id={`BoutiqueSliderSwiperSlide-${sysId}`}
            >
              <Card
                key={sysId}
                preload
                {...cardData}
                className='GalleryItem'
                extraData={extraData?.extraData}
                mediaWrapperType={
                  'SliderFullwidthGallery' as MediaWrapperTypeEnum
                }
                type={type}
              />
            </SwiperSlide>
          );
        })}
      </S.SliderSwiper>
    </S.FullWidthWrapper>
  );
};
